<template>
    <div class="base-layout">
        <Navbar />
        <div class="content">
            <slot></slot>
        </div>
    </div>
</template>

<script>
import Navbar from '@/components/navbar/index.vue'

export default {
    name: 'BaseLayout',
    components: {
        Navbar
    }
}
</script>